module.exports = __webpack_public_path__ + "img/IMG_2248_L_Wood.2a3887a5.jpg";